import { getProviderOutreach } from "@/lib/core/provider-contact.server.ts";
import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import type { BoundaryUnknown } from "@wags/utils/boundary-unknown.ts";
import { resolveContactHandoffRequestSchema } from "@wags/profile-contracts/contact-session.contract.ts";

export const resolveContactHandoff = createServerFn({ method: "GET" })
    .inputValidator((value: BoundaryUnknown) =>
        resolveContactHandoffRequestSchema.parse(value),
    )
    .handler(async ({ data }) => {
        if (!data.token) return null;

        const request = getRequest();
        const outreach = await getProviderOutreach();
        const resolved = await outreach.resolveProviderContactHandoffByToken({
            ...data,
            requestUrl: request.url,
        });
        if (!resolved) return null;

        await outreach.recordProviderContactEvent({
            contactSessionId: resolved.session.id,
            type: "handoff.qr_scanned",
            metadata: {
                handoffPath: "qr_scan",
                intent: resolved.intent,
            },
        });

        if (resolved.session.status === "created") {
            await outreach.markProviderContactHandoffOpened({
                sessionId: resolved.session.id,
                handoffPath: "qr_scan",
                intent: resolved.intent,
            });
        }

        return {
            handoff: resolved.handoff,
            intent: resolved.intent,
            listingId: resolved.session.listingId,
            status: resolved.session.status,
        };
    });
